import { render, staticRenderFns } from "./schools.vue?vue&type=template&id=598fec0e&scoped=true"
import script from "./schools.vue?vue&type=script&lang=js"
export * from "./schools.vue?vue&type=script&lang=js"
import style0 from "./schools.vue?vue&type=style&index=0&id=598fec0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598fec0e",
  null
  
)

export default component.exports